import { ActionTypes } from '../../constants/ActionTypes';

interface IPwaUserConfig {
  pwaTheme: string;
  lang: string;
}

// news
export const onGetPwaUserConfig = () => {
  return {
    type: ActionTypes.GET_PWA_USER_CONFIG,
  };
};

export const fetchPwaUserConfigSuccess = (userConfig: any) => {
  return {
    type: ActionTypes.FETCH_PWA_USER_CONFIG_SUCCESS,
    payload: userConfig,
  };
};

export const setUserConfigSuccess = (data: any) => {
  return {
    type: ActionTypes.SET_USER_CONFIG_SUCCESS,
    payload: data,
  };
};

export const onSetUserConfig = (args: IPwaUserConfig) => {
  return {
    type: ActionTypes.SET_USER_CONFIG,
    payload: args,
  };
};
